export default __webpack_public_path__ + "static/media/Board_01_header.6f4054b3.png";